// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:36:12.424Z
// Property: The Alaskan (ID: 6767906449167166)
// Collections: 15 amenities, 3 floorplans (live), 8 photos, 73 POIs, 5 office hours
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167166",
  "property_external_id": "1101858",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/the-alaskan/5XrTms/",
  "property_apartments_url": "https://www.apartments.com/the-alaskan-anchorage-ak/yvr2h9v/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Alaskan+110+E+11th+Ave,+Anchorage,+AK+99501/@61.2111536,-149.8821676,3a,75y,24.4h,90t/data=!3m4!1e1!3m2!1s40YwYcpAbs5irdj98kJURQ!2e0!4m2!3m1!1s0x56c8962c4fd3a157:0x7de4491e9fce4e9e?sa=X&ved=1t:3780&hl=en&gl=us&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "alaskan",
  "property_name": "The Alaskan",
  "property_website_url": "https://www.alaskanapartmenthomes.com",
  "property_domain": "https://www.alaskanapartmenthomes.com",
  "property_address": "110 E 11th Ave",
  "property_full_address": "110 E 11th Ave, Anchorage, AK 99501",
  "property_address_1": "110 E 11th Ave",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": "99501",
  "property_address_zip": "99501",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "South Addition",
  "property_address_latitude": "61.2113599",
  "property_address_longitude": "-149.8819732",
  "property_email": "thealaskan@weidner.com",
  "property_phone": "(907) 308-5595",
  "property_call_tracking_phone": null,
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Alaskan, your dream retreat in the heart of Anchorage, AK. Choose from our thoughtfully designed studio, one, or two-bedroom apartments, featuring modern amenities like vaulted ceilings, patios, and built-in desks. Enjoy 24-hour access, planned resident events, and a serene smoke-free environment. Your perfect home awaits!",
  "property_long_description": "Welcome to Alaskan, your dream apartment community nestled in the heart of Anchorage, AK! We offer an array of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and comfortable two-bedroom apartments. Each of our residences is meticulously crafted to cater to your lifestyle needs, featuring convenient amenities like a built-in office/desk and linen closet in select units.\n\nOur community brings unparalleled convenience with 24-hour access, on-site maintenance, and a dedicated property manager, ensuring your comfort and peace of mind. Enjoy hassle-free living with online payments and service requests, making managing your home effortless. Our inviting picnic area and planned social activities provide the perfect settings for relaxation and community bonding.\n\nAt Alaskan, we believe in maintaining a smoke-free environment, promoting a healthy lifestyle for all our residents. Each apartment is designed with modern conveniences, including dishwashers, garbage disposals, and vaulted ceilings that create an airy, spacious feel. Embrace outdoor living on your private patio or balcony—perfect for enjoying those beautiful Alaskan evenings!\n\nExplore everything our community has to offer and discover a vibrant lifestyle complemented by attentive service and a friendly neighborhood atmosphere. Don't miss your chance to find your ideal home in Anchorage! Browse our availability today or schedule a tour to experience Alaskan for yourself. Your new home awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-788d-74cb-baa8-deab72c70940.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with large sectional sofa, coffee table, and sliding glass door with view of parking lot.",
    "public_id": "019d021a-788d-74cb-baa8-deab72c70940",
    "storage_key": "property/6767906449167166/019d021a-788d-74cb-baa8-deab72c70940.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "39",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": "84",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.3076923076923",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaskanapartmenthomes.securecafe.com/onlineleasing/the-alaskan/floorplans.aspx",
  "property_resident_portal_url": "https://alaskanapartmenthomes.securecafenet.com/residentservices/the-alaskan/userlogin",
  "property_apply_now_url": "https://alaskanapartmenthomes.securecafe.com/onlineleasing/the-alaskan/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-a608-7298-a42e-988b08fd38b1.webp",
  "property_primary_logo_media": {
    "alt_text": "The Alaskan Apartments logo.",
    "public_id": "019d021a-a608-7298-a42e-988b08fd38b1",
    "storage_key": "property/6767906449167166/019d021a-a608-7298-a42e-988b08fd38b1.webp",
    "width": 483,
    "height": 256
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021c-06f5-72b3-926b-c9e8dffe464d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Alaskan Apartments logo",
    "public_id": "019d021c-06f5-72b3-926b-c9e8dffe464d",
    "storage_key": "property/6767906449167166/019d021c-06f5-72b3-926b-c9e8dffe464d.webp",
    "width": 483,
    "height": 256
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021c-1603-76e8-933d-ecb994970f9d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Alaskan Apartments logo",
    "public_id": "019d021c-1603-76e8-933d-ecb994970f9d",
    "storage_key": "property/6767906449167166/019d021c-1603-76e8-933d-ecb994970f9d.webp",
    "width": 483,
    "height": 256
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#231f20",
  "property_secondary_color": "#000000",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "650 - 750",
  "property_sqft_min": "400",
  "property_sqft_max": "750",
  "property_price_range": "1320 - 1595",
  "property_price_min": "1320",
  "property_price_max": "1595",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/TheAlaskanApartments",
  "property_instagram_url": "https://www.instagram.com/thealaskan108/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJV6HTTyyWyFYRnk7Onx5J5H0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Alaskan",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection Here",
  "property_home_amenities_blurb": "Welcome to Alaskan, where modern living meets comfort in Anchorage, AK. Choose from our stylish floor plans, including studios and two-bedroom options. Enjoy 24-hour access, planned social events, and amenities like laundry facilities and a serene picnic area—all nestled in a smoke-free community designed for your lifestyle. ",
  "property_home_floorplans_blurb": "Experience the charm of Alaskan apartments in the heart of Anchorage, AK. Our thoughtfully designed floor plans cater to every lifestyle, blending comfort with modern aesthetics. Immerse yourself in a vibrant community and envision your new home. Browse our available apartment homes today and uncover the perfect fit for you!",
  "property_home_gallery_blurb": "Welcome to Alaskan, your smoke-free sanctuary in Anchorage, AK! Choose from spacious studios to cozy two-bedrooms, all designed for modern living. With 24-hour access, on-site management, and engaging community events, your new home awaits. Picture yourself relaxing on your patio or enjoying the picnic area. Embrace the lifestyle!",
  "property_home_neighborhood_blurb": "Welcome to Alaskan, where modern living meets the vibrant pulse of Anchorage! Choose from our stylish studio, one-bedroom, or two-bedroom apartments, nestled amidst cultural gems like the Anchorage Museum, Alaska Botanical Garden, and the University of Alaska. Dive into local favorites and enriching experiences, all just steps from home!",
  "property_home_reviews_blurb": "At Alaskan in Anchorage, AK, residents thrive amidst stunning landscapes and vibrant community vibes. One happy tenant raves, \"Living here feels like a breath of fresh air!\" Experience the warmth of our community firsthand. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Alaskan, convenience meets adventure in Anchorage! Surrounded by attractions like the Anchorage Museum, Alaska Botanical Garden, and the scenic Earthquake Park, our community offers a blend of culture and nature. With floor plans tailored for every lifestyle—studio to two-bedroom—set your sights on a vibrant local experience.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Alaskan in Anchorage, AK, vibrant living meets convenience. Choose from studio, one-bedroom, or two-bedroom floor plans, each tailored for your lifestyle. Enjoy 24-hour access, a serene picnic area, and a smoke-free environment, all complemented by thoughtfully designed spaces featuring vaulted ceilings and private patios. Dive into our engaging community!",
  "property_applynow_blurb": "Welcome to Alaskan, where modern living meets comfort in Anchorage, AK. Choose from our thoughtfully designed studio, one, or two-bedroom floor plans, complete with essential amenities like 24-hour access, laundry facilities, and inviting outdoor spaces. Embrace a vibrant community lifestyle—apply now and lease online today!",
  "property_contactus_blurb": "At Alaskan in Anchorage, AK, our diverse floor plans include cozy studios, spacious one-bedrooms, and inviting two-bedrooms, designed to fit your lifestyle. Ready to find your perfect home? Our friendly leasing team is here to answer all your questions—reach out to us today!",
  "property_faqs_blurb": "At Alaskan in Anchorage, AK, choose from a variety of thoughtfully designed floor plans, including studios and spacious one and two-bedroom apartments. Have questions? Our FAQs page offers valuable insights—uncover what makes our community the perfect place to call home!",
  "property_floorplans_blurb": "Welcome to Alaskan, where your ideal living space awaits in the heart of Anchorage, AK. With versatile floor plans including cozy studios, spacious one-bedrooms, and family-friendly two-bedrooms, we cater to all lifestyles. Browse our available apartment homes to find the perfect fit that reflects your unique personality.",
  "property_gallery_blurb": "At Alaskan in Anchorage, AK, our vibrant community invites you to envision life in thoughtfully designed studio, one, and two-bedroom apartments. Enjoy 24-hour access, a picturesque picnic area, and planned social activities. Picture yourself relaxing on your private patio or balcony—your new home awaits! Visit our photo gallery today!",
  "property_interactivemap_blurb": "Welcome to Alaskan, your Anchorage oasis featuring stylish studios, cozy one-bedrooms, and spacious two-bedrooms. Enjoy modern amenities like a patio, vaulted ceilings, and built-in desks. With on-site maintenance, laundry facilities, and vibrant resident events, your perfect apartment is just a click away. Check our interactive map for available homes!",
  "property_pets_blurb": "At Alaskan in Anchorage, your furry friends can join you in comfort and style! With a pet-friendly atmosphere, we welcome two cats or dogs per apartment. Enjoy the great outdoors together, as you create lasting memories in our vibrant community. Note: certain breed restrictions apply for a peaceful living environment.",
  "property_referafriend_blurb": "At Alaskan in Anchorage, AK, great friends make great neighbors. With inviting studio, one-bedroom, and two-bedroom floor plans, you can find the perfect home to share. Refer a friend today and build a vibrant community where connections flourish and memories are made—all against stunning Alaskan backdrops!",
  "property_residentaccess_blurb": "Welcome to Alaskan in Anchorage, AK, where your comfort is our priority. From cozy studios to spacious two-bedroom layouts, our floor plans cater to your lifestyle. Seamlessly manage your home—access the resident portal to pay rent, schedule maintenance, and unlock a world of convenient living today!",
  "property_reviews_blurb": "At Alaskan in Anchorage, AK, our residents are our best advocates! One resident raves, \"The sense of community here is unmatched!\" Ready to see how we create a vibrant living experience? Check out our reviews and find out why so many love calling Alaskan home!",
  "property_created_at": "1771535344064",
  "property_scheduletour_blurb": "At Alaskan in Anchorage, AK, find your perfect home among our diverse floor plans, from cozy studios to spacious two-bedroom apartments. Each layout is thoughtfully designed for comfort and style. Curious about life here? Schedule a tour and hear firsthand from our residents about their vibrant community experiences!",
  "property_thankyou_blurb": "Thank you for sharing your interest in Alaskan Apartments in Anchorage! Whether you crave the cozy charm of a studio or the spacious comfort of a two-bedroom, our diverse floor plans cater to every lifestyle. A team member will be in touch soon to help you find your perfect home.",
  "property_virtualtours_blurb": "Step into your future at Alaskan, where sleek studio, one-bedroom, and two-bedroom apartments await in the heart of Anchorage, AK. Embrace modern living with stunning views and thoughtfully designed spaces. Experience the allure firsthand—take a virtual tour of our vibrant community and find your perfect home today!",
  "property_copyright": "2026 All Rights Reserved. Alaskan",
  "property_seo_title_home": "Alaskan |  Apartments in Anchorage, AK",
  "property_seo_description_home": "Discover modern living at Alaskan in Anchorage! Choose from studios to two-bedroom layouts with top amenities, 24/7 access, and vibrant events!",
  "property_seo_title_floorplans": "Floor Plans | Anchorage, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Alaskan in Anchorage, AK! Choose from cozy studios, spacious one & two bedrooms. Browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Anchorage, AK Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Alaskan in Anchorage! Enjoy spacious studios to two-bedroom homes, 24-hour access, social events, and stunning amenities tailored for you!",
  "property_seo_title_gallery": "Gallery | Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Picture life at Alaskan in Anchorage! Spacious studios to two-bedroom homes with amenities like a picnic area, vaulted ceilings, and planned events await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Alaskan Apartments",
  "property_seo_description_virtualtours": "Experience life at Alaskan in Anchorage, AK! Take a virtual tour of our stunning apartments—choose from studios to two-bedroom layouts.",
  "property_seo_title_interactivemap": "Interactive Map | Alaskan Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Alaskan in Anchorage! Use our interactive map to explore layouts, amenities, and pricing. Your ideal lifestyle awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Uncover Anchorage's hidden gems near Alaskan Apartments! Explore local favorites and vibrant spots surrounding our studio, one, and two-bedroom homes.",
  "property_seo_title_contact": "Contact Us | Alaskan",
  "property_seo_description_contact": "Connect with Alaskan Apartment Homes in Anchorage! Our friendly team is here to help you find your perfect studio, one, or two-bedroom home!",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Get answers to your questions at Alaskan in Anchorage, AK. From floor plans to amenities, our FAQ page sets you on the path to your new home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Join the Alaskan community in Anchorage, AK! Read resident reviews and discover why our studios, one, and two-bedroom apartments feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Elevate your living at Alaskan in Anchorage, AK! Choose from studio to two-bedroom layouts with modern amenities and vibrant community activities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Alaskan",
  "property_seo_description_residentaccess": "Unlock convenience at Alaskan in Anchorage! Log in to the resident portal for easy rent payments, maintenance requests, and updates!",
  "property_seo_title_referafriend": "Refer A Friend | Alaskan",
  "property_seo_description_referafriend": "Great friends make great neighbors at Alaskan Apartments! Refer a buddy today and enjoy exclusive rewards in Anchorage's vibrant community. Join us now!",
  "property_seo_title_scheduletour": "Schedule a Tour | Alaskan",
  "property_seo_description_scheduletour": "Experience the charm of Alaskan living in Anchorage. Schedule a tour today and discover your new home in our vibrant community! Your adventure awaits!",
  "property_seo_title_privacy": "Privacy Policy | Alaskan",
  "property_seo_description_privacy": "At Alaskan in Anchorage, your privacy matters. Dive into our comprehensive policy detailing how we protect your information. Your trust is our priority.",
  "property_seo_title_accessibility": "Website Accessibility | Alaskan",
  "property_seo_description_accessibility": "At Alaskan in Anchorage, we prioritize accessibility and digital inclusion for all. Join us in creating a community where your comfort matters!",
  "property_seo_title_sitemap": "Sitemap | Alaskan",
  "property_seo_description_sitemap": "Uncover every corner of Alaskan Apartments in Anchorage, AK. Navigate our sitemap for essential info and a seamless living experience. Check it out!",
  "property_seo_title_thankyou": "Thank You | Alaskan",
  "property_seo_description_thankyou": "Thank you for your interest in Alaskan Apartments! Our team will reach out soon to help you take the next step towards your new Anchorage home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654963789",
  "amenities": [
    {
      "id": "ec_070ae2a938ffd1b8b179c514",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455789",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db3a618dcfaeb7a0eb798790",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455791",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a8d625d566b02d16785cda8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455792",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7ec9b875b164e02a57ab6f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455793",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72c6e514576e590be99dcadd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455808",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51c744fbc8dbf1bc7c2e6307",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455809",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d9a32-60a7-7059-961b-36956e9cde7c.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white refrigerator, wooden cabinets, stovetop, sink, and dishwasher.",
        "public_id": "019d9a32-60a7-7059-961b-36956e9cde7c",
        "storage_key": "property/6767906449167166/019d9a32-60a7-7059-961b-36956e9cde7c.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "The Alaskan Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c233a9ca56ea8b69e9ff5a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455810",
      "title": "Garbage Disposal*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f559228b27f56661dfb8261",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455812",
      "title": "Linen Closet*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a315c6e977945a3c7af935c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455813",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3aef61c73971fac743b3cd4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455811",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6209e2d017b0ae2c8700262",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455814",
      "title": "Built-In Office/Desk*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03a52d23997c104e7b3a0446",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455794",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8d59a73f030df3be929d891",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455795",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9118167a3f96865e3ddf069b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455796",
      "title": "Planned Social Activities/ Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e3850cac3e9d4a2c7211377",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "87455797",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_9cea59b97b167d88e349adc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-788d-74cb-baa8-deab72c70940.webp",
      "image_media": {
        "alt_text": "Living room with large sectional sofa, coffee table, and sliding glass door with view of parking lot.",
        "public_id": "019d021a-788d-74cb-baa8-deab72c70940",
        "storage_key": "property/6767906449167166/019d021a-788d-74cb-baa8-deab72c70940.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a modern coffee table, and large sliding glass doors that open to a scenic view of the surrounding area.",
      "link": "false",
      "alt_text": "A bright living room at The Alaskan featuring plush carpet, a modern sectional sofa, and a round coffee table on a neutral rug. Soft artwork and plants add warmth, while a large sliding glass door opens to a balcony with views of the parking area and nearby greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(1).jpg"
    },
    {
      "id": "ec_7b287ea45279fbba18ec60e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-7912-74ff-bc77-d672924833a6.webp",
      "image_media": {
        "alt_text": "Clean kitchen with white cabinets, stove, dishwasher, and coffee maker.",
        "public_id": "019d021a-7912-74ff-bc77-d672924833a6",
        "storage_key": "property/6767906449167166/019d021a-7912-74ff-bc77-d672924833a6.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring ample white cabinetry, a full-size stove, dishwasher, and a convenient coffee maker for your morning routine.",
      "link": "false",
      "alt_text": "A bright kitchen at The Alaskan with white cabinets, laminate countertops, and a matching white stove, sink, and dishwasher. Light flooring and simple décor, including a fruit bowl and cutting board, create a clean and functional cooking space with plenty of storage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(2).jpg"
    },
    {
      "id": "ec_9dfc100ddf2b49bc0ee5e70b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-7895-75d5-a9c5-6f6da8ac771e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, and a window view.",
        "public_id": "019d021a-7895-75d5-a9c5-6f6da8ac771e",
        "storage_key": "property/6767906449167166/019d021a-7895-75d5-a9c5-6f6da8ac771e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-sized bed, elegant nightstands, and a large window offering a view of the outdoors. Perfect for relaxation and peaceful nights.",
      "link": "false",
      "alt_text": "A bright bedroom at The Alaskan with soft carpeting and warm neutral walls. The space features a neatly made bed with matching bedding, two bedside tables with lamps, and a dresser. A large window brings in natural light and offers views of the surrounding neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(3).jpg"
    },
    {
      "id": "ec_1bd169f48a4f3667c326e627",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-787d-747d-8c1a-e88ffbe48b92.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, mirror, toilet, and shower",
        "public_id": "019d021a-787d-747d-8c1a-e88ffbe48b92",
        "storage_key": "property/6767906449167166/019d021a-787d-747d-8c1a-e88ffbe48b92.webp",
        "width": 380,
        "height": 275
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity, a clean toilet, and a frosted glass shower enclosure. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "A clean bathroom at The Alaskan featuring a combination shower and tub with sliding glass doors. The vanity includes a single sink, countertop space, and a wall-mounted mirror with storage. Bright lighting, neutral walls, and simple décor complete the functional space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(4).jpg"
    },
    {
      "id": "ec_66b65440d8146eacc06b294e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-8403-77d7-b08f-3a860b746201.webp",
      "image_media": {
        "alt_text": "Exterior view of a dark wood-sided apartment building with white trim and balconies.",
        "public_id": "019d021a-8403-77d7-b08f-3a860b746201",
        "storage_key": "property/6767906449167166/019d021a-8403-77d7-b08f-3a860b746201.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring dark wood siding, white accents, and private balconies. Plenty of green space and trees surround the property.",
      "link": "false",
      "alt_text": "A three-story exterior view of The Alaskan with dark siding, white trim, and private balconies on each level. Mature evergreens and open lawn space create a natural setting, with a picnic table and bicycles adding to the community-friendly atmosphere under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(5).jpg"
    },
    {
      "id": "ec_23f9c971c26484345fe03982",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-8555-7604-a708-6e57d07c046b.webp",
      "image_media": {
        "alt_text": "Exterior of a dark gray multifamily building with a green lawn and sidewalk.",
        "public_id": "019d021a-8555-7604-a708-6e57d07c046b",
        "storage_key": "property/6767906449167166/019d021a-8555-7604-a708-6e57d07c046b.webp",
        "width": 380,
        "height": 275
      },
      "title": "Community",
      "description": "Exterior view of the multifamily property showcasing its dark gray facade, landscaping, and entrance.",
      "link": "false",
      "alt_text": "The leasing office at The Alaskan with dark siding, white trim, and welcoming front steps leading to the entrance. A large front window looks out onto a well-kept lawn with mature trees and a sidewalk, creating a friendly neighborhood feel on a bright day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(6).jpg"
    },
    {
      "id": "ec_5447757d7af545cf059a9cef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-8634-77de-915f-21f5ea7a1918.webp",
      "image_media": {
        "alt_text": "Exterior view of a dark-colored apartment building with white balconies and large evergreen trees.",
        "public_id": "019d021a-8634-77de-915f-21f5ea7a1918",
        "storage_key": "property/6767906449167166/019d021a-8634-77de-915f-21f5ea7a1918.webp",
        "width": 380,
        "height": 275
      },
      "title": "Community",
      "description": "Exterior view of a dark-colored apartment building with white balconies and large evergreen trees. Discover your new home today!",
      "link": "false",
      "alt_text": "A three-story residential building at The Alaskan with dark siding, white trim, and private balconies on each level. Evergreen trees and open space surround the exterior, creating a peaceful neighborhood atmosphere beneath a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(7).jpg"
    },
    {
      "id": "ec_2875db1e35c11c064abe7926",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021a-89ac-733f-bbcb-a87d236deddf.webp",
      "image_media": {
        "alt_text": "Exterior of a dark-colored apartment building with dormer windows and trees.",
        "public_id": "019d021a-89ac-733f-bbcb-a87d236deddf",
        "storage_key": "property/6767906449167166/019d021a-89ac-733f-bbcb-a87d236deddf.webp",
        "width": 3072,
        "height": 1587
      },
      "title": "Community",
      "description": "Exterior view of a multifamily apartment building featuring dark siding, white trim, dormer windows, and lush green trees.",
      "link": "false",
      "alt_text": "A long single-story building at The Alaskan with dark siding, white trim, and multiple front entrances accessed by small stairways. Mature trees line the sidewalk and grassy lawn, creating a residential neighborhood feel.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alaskan_Favorites%20(8).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7253948b-f6ec-4864-aedb-94e427d6ab16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-14a9-747b-b955-4718c96ea3be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-14a9-747b-b955-4718c96ea3be",
        "storage_key": "property/6767906449167166/019d021b-14a9-747b-b955-4718c96ea3be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8238-72bf-b436-d36744108564.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8238-72bf-b436-d36744108564",
        "storage_key": "property/6767906449167166/019d021b-8238-72bf-b436-d36744108564.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_9decf923-1d1a-44d7-a846-e00b950c5358",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-1fa0-726a-87ea-2e25e4dc1fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-1fa0-726a-87ea-2e25e4dc1fe4",
        "storage_key": "property/6767906449167166/01a10de4-1fa0-726a-87ea-2e25e4dc1fe4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_3de6c101-b635-4b13-8160-2bff4a7aea97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Orso",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_long_description": "A menu of local seafood & grilled meats, as well as 20+ wines by the glass, in a welcoming space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d292-75a9-91f0-3646d3e30803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d292-75a9-91f0-3646d3e30803",
        "storage_key": "property/6767906449167166/01a10de6-d292-75a9-91f0-3646d3e30803.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://orsoalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688852827403958754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orso",
      "poi_latitude": "61.2176833",
      "poi_longitude": "-149.8961662",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-222-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYR4rlzElC4dYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_08b817a2-dcf1-451f-bc63-af1d2319563f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Simon & Seafort's Saloon & Grill",
      "poi_type": "Restaurants",
      "poi_address": "420 L St, Anchorage, AK 99501, USA",
      "poi_short_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_long_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-149a-73c8-92a1-807aa3332047.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-149a-73c8-92a1-807aa3332047",
        "storage_key": "property/6767906449167166/019d021b-149a-73c8-92a1-807aa3332047.webp",
        "width": 600,
        "height": 441
      },
      "poi_business_url": "https://www.simonandseaforts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1709221909627021300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simon--seaforts-saloon--grill",
      "poi_latitude": "61.2179842",
      "poi_longitude": "-149.9043854",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5_VXoG9yFYR9CeiXUVguBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9dd0cefc-b63b-4c7c-b843-b3405ff325fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Crow's Nest",
      "poi_type": "Restaurants",
      "poi_address": "939 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "High-end restaurant offering French & New American cuisine, an extensive wine list & scenic views.",
      "poi_long_description": "High-end restaurant offering French & New American cuisine, an extensive wine list & scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d5d1-773b-89d1-1774f875d33b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d5d1-773b-89d1-1774f875d33b",
        "storage_key": "property/6767906449167166/01a10de6-d5d1-773b-89d1-1774f875d33b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.captaincook.com/dining/crows-nest",
      "poi_directions_map_url": "https://maps.google.com/?cid=3666166427093759864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crows-nest",
      "poi_latitude": "61.21777780000001",
      "poi_longitude": "-149.9",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-276-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUUNNIG9yFYRePdi9vDW4DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_b525c3a8-4e21-4612-aad4-aa084e8008ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "F Street Station",
      "poi_type": "Restaurants",
      "poi_address": "325 F St, Anchorage, AK 99501, USA",
      "poi_short_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_long_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d701-76e6-b403-f0cb858d5953.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d701-76e6-b403-f0cb858d5953",
        "storage_key": "property/6767906449167166/01a10de6-d701-76e6-b403-f0cb858d5953.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://fstreetstation.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=497107031803204211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f-street-station",
      "poi_latitude": "61.2189375",
      "poi_longitude": "-149.8931451",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-272-5196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtc6fbYe9yFYRc5L6LTYU5gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_552ea559-7de4-4e0f-bad7-73d1dd31db1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Ginger",
      "poi_type": "Restaurants",
      "poi_address": "425 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Stylish restaurant & lounge specializing in Pacific Rim cuisine, plus microbrews & cocktails.",
      "poi_long_description": "Stylish restaurant & lounge specializing in Pacific Rim cuisine, plus microbrews & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d290-738a-ab8e-bc9c0acd8bc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d290-738a-ab8e-bc9c0acd8bc4",
        "storage_key": "property/6767906449167166/01a10de6-d290-738a-ab8e-bc9c0acd8bc4.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.gingeralaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1970017419952325841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ginger",
      "poi_latitude": "61.217691",
      "poi_longitude": "-149.8905035",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-929-3680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxXi3CmWyFYR0QSX5WfoVhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_dca79d15-abda-4704-ad0e-0c6b453a02b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Humpy's Great Alaskan Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "610 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_long_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-1fb1-759f-bac9-77c5141f490b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-1fb1-759f-bac9-77c5141f490b",
        "storage_key": "property/6767906449167166/019d021b-1fb1-759f-bac9-77c5141f490b.webp",
        "width": 904,
        "height": 720
      },
      "poi_business_url": "https://www.humpysalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2859243613023281808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "humpys-great-alaskan-alehouse",
      "poi_latitude": "61.216342",
      "poi_longitude": "-149.894083",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-276-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14LWxYC9yFYRkKKOyOoSric",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_aec768f2-a441-42f5-a423-217af7f3bded",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "La Cabaña Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "312 E 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Enduring outlet for Mexican staples like tacos, fajitas & enchiladas, plus a weekend brunch buffet.",
      "poi_long_description": "Enduring outlet for Mexican staples like tacos, fajitas & enchiladas, plus a weekend brunch buffet.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d42c-7169-ad30-9af4fa6d4c12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d42c-7169-ad30-9af4fa6d4c12",
        "storage_key": "property/6767906449167166/01a10de6-d42c-7169-ad30-9af4fa6d4c12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lacabanamexicanrestaurant.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17945514313855745910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-cabaa-mexican-restaurant",
      "poi_latitude": "61.2182061",
      "poi_longitude": "-149.8786538",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-272-0135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cXgsyiWyFYRdj8PZTBGC_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_1fe630df-be81-42d2-9d1b-43b5a07ad697",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Crush Wine Bistro & Cellar",
      "poi_type": "Restaurants",
      "poi_address": "328 G St, Anchorage, AK 99501, USA",
      "poi_short_description": "A huge variety of wines by the glass or bottle & shareable plates in an unpretentious atmosphere.",
      "poi_long_description": "A huge variety of wines by the glass or bottle & shareable plates in an unpretentious atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d4f1-7404-944f-9bb8ecdbfd5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d4f1-7404-944f-9bb8ecdbfd5d",
        "storage_key": "property/6767906449167166/01a10de6-d4f1-7404-944f-9bb8ecdbfd5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crushak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14560653215250281962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crush-wine-bistro--cellar",
      "poi_latitude": "61.218994",
      "poi_longitude": "-149.8957585",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-865-9198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyGVmSmWyFYR6nWkIPTUEco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_c0f0f6ff-d7a1-4357-bc9e-172f60376824",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Kumagoro",
      "poi_type": "Restaurants",
      "poi_address": "533 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic Japanese fare served in a humble spot with baskets of plants hanging from its high ceilings.",
      "poi_long_description": "Classic Japanese fare served in a humble spot with baskets of plants hanging from its high ceilings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d632-7081-b91a-9d45de7a5c11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d632-7081-b91a-9d45de7a5c11",
        "storage_key": "property/6767906449167166/01a10de6-d632-7081-b91a-9d45de7a5c11.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kumagoroak.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16741793788025587151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kumagoro",
      "poi_latitude": "61.2187459",
      "poi_longitude": "-149.8928258",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-272-9905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI29Dboe9yFYRz0Ublr_MVug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_307c0bd9-14e4-429d-b6f2-691363e9cb2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Flattop Pizza + Pool",
      "poi_type": "Restaurants",
      "poi_address": "600 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Laid-back eatery & bar featuring a menu of pizza, pasta, craft beers & cocktails, plus pool tables.",
      "poi_long_description": "Laid-back eatery & bar featuring a menu of pizza, pasta, craft beers & cocktails, plus pool tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d4a1-71ed-b773-b92769e7e15a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d4a1-71ed-b773-b92769e7e15a",
        "storage_key": "property/6767906449167166/01a10de6-d4a1-71ed-b773-b92769e7e15a.webp",
        "width": 720,
        "height": 786
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11027347721897645431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flattop-pizza--pool",
      "poi_latitude": "61.216475",
      "poi_longitude": "-149.8937991",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-230-5423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL6-TqoC9yFYRdxVs4lMCCZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d8145c1c-f905-4742-b464-c9522d257f3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Anchorage Cider House | Fat Ptarmigan",
      "poi_type": "Restaurants",
      "poi_address": "441 W 5th Ave Ste 100, Anchorage, AK 99501, USA",
      "poi_short_description": "Sleek bistro serving a locally focused menu of gourmet wood-fired pizzas & craft beer & wine.",
      "poi_long_description": "Sleek bistro serving a locally focused menu of gourmet wood-fired pizzas & craft beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d685-7479-8dbd-fd6ab651d145.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d685-7479-8dbd-fd6ab651d145",
        "storage_key": "property/6767906449167166/01a10de6-d685-7479-8dbd-fd6ab651d145.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18360868744669844648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-cider-house--fat-ptarmigan",
      "poi_latitude": "61.2177071",
      "poi_longitude": "-149.8911649",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-777-7710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6ev4CmWyFYRqFSe3dfozv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_803c0ed0-96ec-4b2e-a12a-3cbfb832d3e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Muse",
      "poi_type": "Restaurants",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Bright, fashionable American mainstay with select seafood & steak dishes, plus beer & wine tastings.",
      "poi_long_description": "Bright, fashionable American mainstay with select seafood & steak dishes, plus beer & wine tastings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-d9a3-767f-a05f-bd48afe861da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-d9a3-767f-a05f-bd48afe861da",
        "storage_key": "property/6767906449167166/01a10de6-d9a3-767f-a05f-bd48afe861da.webp",
        "width": 1280,
        "height": 623
      },
      "poi_business_url": "https://www.anchoragemuseum.org/visit/muse/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15234275050183606234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muse",
      "poi_latitude": "61.21585870000001",
      "poi_longitude": "-149.8853554",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-929-9210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81ef-7502-a099-60cd0557ed59",
        "storage_key": "property/6767906449167166/019d021b-81ef-7502-a099-60cd0557ed59.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYR2j_KiHEEa9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1f1601aa-fb5b-4202-82a8-dce969f29456",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-dae6-7562-922c-7a81f5abebe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-dae6-7562-922c-7a81f5abebe7",
        "storage_key": "property/6767906449167166/01a10de6-dae6-7562-922c-7a81f5abebe7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-81f8-72dd-934a-6554508e14cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-81f8-72dd-934a-6554508e14cf",
        "storage_key": "property/6767906449167166/019d021b-81f8-72dd-934a-6554508e14cf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9ed09bb6-f8fb-450c-a6cf-4d73abf92b62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1340 Gambell St, Anchorage, AK 99501, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-dc55-70b9-aeaf-33d48d42da65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-dc55-70b9-aeaf-33d48d42da65",
        "storage_key": "property/6767906449167166/01a10de6-dc55-70b9-aeaf-33d48d42da65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/1340-gambell-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9961248244631618970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.20930699999999",
      "poi_longitude": "-149.8718003",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-339-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8542-70ec-954f-07d07eec40a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8542-70ec-954f-07d07eec40a1",
        "storage_key": "property/6767906449167166/019d021b-8542-70ec-954f-07d07eec40a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeWJRTKWyFYRmkXAZIB2PYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9c58544f-a92a-42a0-8ef3-ec1116bf7877",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "New Sagaya City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 W 13th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Downtown grocery store featuring fresh seafood and a variety of prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-dd51-7602-8d38-53dcaf2f5239.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-dd51-7602-8d38-53dcaf2f5239",
        "storage_key": "property/6767906449167166/01a10de6-dd51-7602-8d38-53dcaf2f5239.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "https://newsagaya.com/locations/city-market/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10317338999052903724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-sagaya-city-market",
      "poi_latitude": "61.2093953",
      "poi_longitude": "-149.9004858",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-6173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8542-70ec-954f-07d07eec40a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8542-70ec-954f-07d07eec40a1",
        "storage_key": "property/6767906449167166/019d021b-8542-70ec-954f-07d07eec40a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQBHqHmXyFYRLCXV8SeNLo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cbd43bbb-4cbe-439d-ab39-7ce940b1c033",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Anchorage 5th Avenue Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "320 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-2319-742e-a81b-84c80eb4374c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-2319-742e-a81b-84c80eb4374c",
        "storage_key": "property/6767906449167166/01a10de4-2319-742e-a81b-84c80eb4374c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/anchorage-5th-avenue-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=569891450485103965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-5th-avenue-mall",
      "poi_latitude": "61.2169618",
      "poi_longitude": "-149.888269",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-258-5535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8617-72a8-8c8d-62db5a6f0a9e",
        "storage_key": "property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH0jnvSmWyFYRXV2yOkGp6Ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_034dcf60-68c4-4372-950c-3f49349af9cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Polar Bear Gifts",
      "poi_type": "Shopping & Retail",
      "poi_address": "442 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "T-shirts, hoodies, and other Alaskan souvenirs are sold at this shop in the 5th Avenue Mall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-de14-739d-b0cb-09ba19e83891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-de14-739d-b0cb-09ba19e83891",
        "storage_key": "property/6767906449167166/01a10de6-de14-739d-b0cb-09ba19e83891.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://polarbeargifts.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16573398040081163549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "polar-bear-gifts",
      "poi_latitude": "61.21727979999999",
      "poi_longitude": "-149.8908642",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-274-4387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8617-72a8-8c8d-62db5a6f0a9e",
        "storage_key": "property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_c3JqCSXyFYRHWUxNLWJAOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_314b64ec-3052-4720-a75c-06eb80976d55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Sara's Gift Cache",
      "poi_type": "Shopping & Retail",
      "poi_address": "408 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e0be-7593-a79f-2696b040adbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e0be-7593-a79f-2696b040adbe",
        "storage_key": "property/6767906449167166/01a10de6-e0be-7593-a79f-2696b040adbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12479928320613771883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saras-gift-cache",
      "poi_latitude": "61.2184312",
      "poi_longitude": "-149.8899317",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-272-3877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8617-72a8-8c8d-62db5a6f0a9e",
        "storage_key": "property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQVAC1CmWyFYRa2qFpK-cMa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_ba99e24e-9b27-4366-b36e-ee6bf509ba9b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Chevron Denali Express",
      "poi_type": "Transportation & Transit",
      "poi_address": "832 E 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Gas station with a convenience store and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e056-707b-ad8f-8fd990a113ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e056-707b-ad8f-8fd990a113ff",
        "storage_key": "property/6767906449167166/01a10de6-e056-707b-ad8f-8fd990a113ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.denaliexpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8218989768418565359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-denali-express",
      "poi_latitude": "61.2163201",
      "poi_longitude": "-149.8674242",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-272-1649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-1166-707d-899d-f111342c9bf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-1166-707d-899d-f111342c9bf0",
        "storage_key": "property/6767906449167166/01a10de7-1166-707d-899d-f111342c9bf0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJcd4d_y-WyFYR75wo96W3D3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_3bd0d9c6-c244-4ecb-9ed3-147738bed8a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Railroad Giftshop",
      "poi_type": "Shopping & Retail",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-dece-744b-b8af-94e052026b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-dece-744b-b8af-94e052026b22",
        "storage_key": "property/6767906449167166/01a10de6-dece-744b-b8af-94e052026b22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskarailroadgiftshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1270630692970004460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-railroad-giftshop",
      "poi_latitude": "61.2216964",
      "poi_longitude": "-149.8901899",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-265-2326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8617-72a8-8c8d-62db5a6f0a9e",
        "storage_key": "property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcaxI3Ie9yFYR7H8vF-IvohE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_8905b9fe-ee29-4bbb-b2d2-be606daf241f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Trek Bicycle Store of Anchorage",
      "poi_type": "Shopping & Retail",
      "poi_address": "530 E Benson Blvd Ste 9C, Anchorage, AK 99503, USA",
      "poi_short_description": "Knowledgeable bicycle shop offering expert bike fitting and professional repair services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-de68-7619-8d66-17f98c002273.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-de68-7619-8d66-17f98c002273",
        "storage_key": "property/6767906449167166/01a10de6-de68-7619-8d66-17f98c002273.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://trekstorealaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13499743987199676115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trek-bicycle-store-of-anchorage",
      "poi_latitude": "61.19241259999999",
      "poi_longitude": "-149.8741935",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-743-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8617-72a8-8c8d-62db5a6f0a9e",
        "storage_key": "property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdZhaB8iXyFYR047As6G5WLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bicycle_store"
    },
    {
      "id": "custom_0451489f-cacf-45e0-bc4a-dcbf475a932e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Big Ray's",
      "poi_type": "Shopping & Retail",
      "poi_address": "320 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan outdoor outfitter providing extensive gear for fishing, hunting, and cold-weather recreation.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e16a-7368-b0c1-bb5bc91a8f1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e16a-7368-b0c1-bb5bc91a8f1f",
        "storage_key": "property/6767906449167166/01a10de6-e16a-7368-b0c1-bb5bc91a8f1f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.bigrays.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16552316327722252708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-rays",
      "poi_latitude": "61.21842529999999",
      "poi_longitude": "-149.8882405",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-279-2401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8617-72a8-8c8d-62db5a6f0a9e",
        "storage_key": "property/6767906449167166/019d021b-8617-72a8-8c8d-62db5a6f0a9e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7xBHyymWyFYRpHnIiwCkteU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_9461b0c0-3ee0-4f88-b25c-e4205e15ed73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Inlet View Elementary School",
      "poi_type": "Education",
      "poi_address": "1219 N St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/inletview",
      "poi_directions_map_url": "https://maps.google.com/?cid=15879806796927077653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inlet-view-elementary-school",
      "poi_latitude": "61.2104006",
      "poi_longitude": "-149.9050422",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-7630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVUUNSn69yFYRFQ2soCVoYNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dd6aa1a0-f098-43e5-b650-ba1abe4e6128",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Denali Montessori Elementary",
      "poi_type": "Education",
      "poi_address": "952 Cordova St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e190-74db-bf09-2fb9bcb397b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e190-74db-bf09-2fb9bcb397b8",
        "storage_key": "property/6767906449167166/01a10de6-e190-74db-bf09-2fb9bcb397b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.asdk12.org/denali",
      "poi_directions_map_url": "https://maps.google.com/?cid=1186072429240973860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denali-montessori-elementary",
      "poi_latitude": "61.2133423",
      "poi_longitude": "-149.8802946",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-742-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWfcvIiyWyFYRJPrKHpfGdRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_407eb72c-4bc5-415c-b5c9-9e7189337a79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Chugach Optional School",
      "poi_type": "Education",
      "poi_address": "1205 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e5e6-7787-9008-860064701f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e5e6-7787-9008-860064701f60",
        "storage_key": "property/6767906449167166/01a10de6-e5e6-7787-9008-860064701f60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/schools/chugach_optional/pages/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16411520343823506372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chugach-optional-school",
      "poi_latitude": "61.21009849999999",
      "poi_longitude": "-149.8905996",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-3730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7Z2VrCyWyFYRxFuy_cxuweM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e5c2d2ae-941d-4954-8a0d-f37ddea0d718",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Central Middle School of Science",
      "poi_type": "Education",
      "poi_address": "1405 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e575-73cf-87f8-2b9b8c30f819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e575-73cf-87f8-2b9b8c30f819",
        "storage_key": "property/6767906449167166/01a10de6-e575-73cf-87f8-2b9b8c30f819.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://central.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12980891005085165217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-middle-school-of-science",
      "poi_latitude": "61.2083004",
      "poi_longitude": "-149.8893498",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ9ZwCpOWyFYRoSYq6pdjJbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_42443069-0a67-4668-8a85-f5c827607a95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Government Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "525 E Bluff Dr, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/governmenthill",
      "poi_directions_map_url": "https://maps.google.com/?cid=14334643322608791820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-hill-elementary-school",
      "poi_latitude": "61.2333973",
      "poi_longitude": "-149.8707413",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-742-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJV8tVPW9yFYRDLEFWifi7sY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2bce4945-a83a-4a15-81e6-4427d22ce5db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e622-71fd-8964-59f8cb922174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e622-71fd-8964-59f8cb922174",
        "storage_key": "property/6767906449167166/01a10de6-e622-71fd-8964-59f8cb922174.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.1939631",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e056544f-2a4d-4cf0-bc69-1cd50951ba35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "West Anchorage High School",
      "poi_type": "Education",
      "poi_address": "1700 Hillcrest Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e70e-716b-8282-f75fd43f7d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e70e-716b-8282-f75fd43f7d53",
        "storage_key": "property/6767906449167166/01a10de6-e70e-716b-8282-f75fd43f7d53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://west.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15684090881757896505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-anchorage-high-school",
      "poi_latitude": "61.2007784",
      "poi_longitude": "-149.9166486",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-742-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeXfsf2K9yFYROV8fII8Vqdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5ce5e956-999f-4431-b8d3-fde26acbfaf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-4027-705f-a65b-802b3f47ec24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-4027-705f-a65b-802b3f47ec24",
        "storage_key": "property/6767906449167166/019d021b-4027-705f-a65b-802b3f47ec24.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_eb4574b1-ede0-4043-9658-1403d4472958",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-406f-766f-bd37-a388b0112cef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-406f-766f-bd37-a388b0112cef",
        "storage_key": "property/6767906449167166/019d021b-406f-766f-bd37-a388b0112cef.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5243aa41-02d9-4c61-9a94-466341ec7f6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Holy Rosary Academy",
      "poi_type": "Education",
      "poi_address": "1846 E 64th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-e93a-72dd-97b9-28973f734419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-e93a-72dd-97b9-28973f734419",
        "storage_key": "property/6767906449167166/01a10de6-e93a-72dd-97b9-28973f734419.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.hraak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3253552454997321548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-rosary-academy",
      "poi_latitude": "61.1618452",
      "poi_longitude": "-149.8482473",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-276-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGY3NDNqXyFYRTCc3QrjwJi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5f5cd9d4-f25f-4653-ac73-9b40b9314c95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-449f-74a5-9011-6efe2f575f80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-449f-74a5-9011-6efe2f575f80",
        "storage_key": "property/6767906449167166/019d021b-449f-74a5-9011-6efe2f575f80.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-117b-7227-9282-d8cde122fae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-117b-7227-9282-d8cde122fae4",
        "storage_key": "property/6767906449167166/01a10de7-117b-7227-9282-d8cde122fae4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_58e28a95-2576-4049-b618-0139d34dc651",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-25d4-7777-a684-266206b65fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-25d4-7777-a684-266206b65fe6",
        "storage_key": "property/6767906449167166/01a10de4-25d4-7777-a684-266206b65fe6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89de-70ae-8f99-b2dcc8087c35",
        "storage_key": "property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b4ed24c2-1553-4174-a3fc-31660d19a647",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Oscar Anderson House Museum",
      "poi_type": "Entertainment",
      "poi_address": "420 M St, Anchorage, AK 99501, USA",
      "poi_short_description": "Built in 1915, this home is filled with antiques & serves as a monument to early Anchorage life.",
      "poi_long_description": "Built in 1915, this home is filled with antiques & serves as a monument to early Anchorage life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-eadd-74e6-83d1-f7be250e8b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-eadd-74e6-83d1-f7be250e8b07",
        "storage_key": "property/6767906449167166/01a10de6-eadd-74e6-83d1-f7be250e8b07.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.oscarandersonhousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=128384008720912302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oscar-anderson-house-museum",
      "poi_latitude": "61.21856469999999",
      "poi_longitude": "-149.9060092",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-206-2284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89de-70ae-8f99-b2dcc8087c35",
        "storage_key": "property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvy0C74O9yFYRro-mYpMcyAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_01977111-3340-4624-a734-b12a4d937e22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Dena’ina Civic and Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "600 W 7th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Versatile downtown convention center hosting diverse conferences and public events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-ec74-74ba-a841-6b7ede232e26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-ec74-74ba-a841-6b7ede232e26",
        "storage_key": "property/6767906449167166/01a10de6-ec74-74ba-a841-6b7ede232e26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://denaina.anchorageconventioncenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13102333279014608095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denaina-civic-and-convention-center",
      "poi_latitude": "61.2154727",
      "poi_longitude": "-149.8946224",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-263-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-4518-772f-87c5-7f39e6778cab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de4-4518-772f-87c5-7f39e6778cab",
        "storage_key": "property/6767906449167166/01a10de4-4518-772f-87c5-7f39e6778cab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaMkCiqWyFYR39xxuLLW1LU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_51f1adde-cd5d-4a23-b38b-50a7d14b5e8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "William A. Egan Civic & Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "555 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Downtown convention center offering flexible meeting space and traveler services including luggage storage and airport shuttles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-ecc0-722e-902b-c03c57f614b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-ecc0-722e-902b-c03c57f614b4",
        "storage_key": "property/6767906449167166/01a10de6-ecc0-722e-902b-c03c57f614b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2086414584322602747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-a-egan-civic--convention-center",
      "poi_latitude": "61.21773589999999",
      "poi_longitude": "-149.8916534",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-263-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-4518-772f-87c5-7f39e6778cab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de4-4518-772f-87c5-7f39e6778cab",
        "storage_key": "property/6767906449167166/01a10de4-4518-772f-87c5-7f39e6778cab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaMkCiqWyFYR-za-mAJv9Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_a2bd073d-cf1f-4c19-b462-a5f395887b57",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-26ff-73eb-bb70-56f2dbe65945.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-26ff-73eb-bb70-56f2dbe65945",
        "storage_key": "property/6767906449167166/01a10de4-26ff-73eb-bb70-56f2dbe65945.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.9719066",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89de-70ae-8f99-b2dcc8087c35",
        "storage_key": "property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b9627f50-55c1-487c-9a31-f5f1d20dd2a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-4769-7547-ae78-967f4685116e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-4769-7547-ae78-967f4685116e",
        "storage_key": "property/6767906449167166/019d021b-4769-7547-ae78-967f4685116e.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89de-70ae-8f99-b2dcc8087c35",
        "storage_key": "property/6767906449167166/019d021b-89de-70ae-8f99-b2dcc8087c35.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_5b1038ac-2141-4e65-95d4-0f7cf619e572",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-edf6-7471-abf5-1e0031bcd066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-edf6-7471-abf5-1e0031bcd066",
        "storage_key": "property/6767906449167166/01a10de6-edf6-7471-abf5-1e0031bcd066.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-1176-75d8-a7b0-ed47ec6a9ec2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-1176-75d8-a7b0-ed47ec6a9ec2",
        "storage_key": "property/6767906449167166/01a10de7-1176-75d8-a7b0-ed47ec6a9ec2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b251642a-2e65-4b76-a752-42b56ef0f825",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-3123-76de-85e5-8a96d89b8e09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-3123-76de-85e5-8a96d89b8e09",
        "storage_key": "property/6767906449167166/01a10de4-3123-76de-85e5-8a96d89b8e09.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e0f-72e7-9aa4-1dfcc998bdfa",
        "storage_key": "property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d692ff9b-4e84-407f-97c5-4a9aad8619be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-557b-71aa-b0cb-35d1cba9fc48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-557b-71aa-b0cb-35d1cba9fc48",
        "storage_key": "property/6767906449167166/019d021b-557b-71aa-b0cb-35d1cba9fc48.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e0f-72e7-9aa4-1dfcc998bdfa",
        "storage_key": "property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e9254276-582f-41f7-be32-81d8ffce01de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Walk-In Clinic at ANMC",
      "poi_type": "Health and Wellness",
      "poi_address": "3900 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-ef42-75bf-9fa7-f36144d4e7cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-ef42-75bf-9fa7-f36144d4e7cb",
        "storage_key": "property/6767906449167166/01a10de6-ef42-75bf-9fa7-f36144d4e7cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.anthc.org/departments/walk-in-clinic/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=11752471834691715911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walk-in-clinic-at-anmc",
      "poi_latitude": "61.18238059999999",
      "poi_longitude": "-149.8066864",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-729-1680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e0f-72e7-9aa4-1dfcc998bdfa",
        "storage_key": "property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-55cH7OXyFYRR0OVy90qGaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5db14c75-a528-4f58-bd28-847eac0b145f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Credena Health Pharmacy Anchorage",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Providence Dr #101, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f137-7778-b7a6-7c1ea3a567db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f137-7778-b7a6-7c1ea3a567db",
        "storage_key": "property/6767906449167166/01a10de6-f137-7778-b7a6-7c1ea3a567db.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "https://www.cornerdrugstore.com/?corpID=308200&pharmID=1995",
      "poi_directions_map_url": "https://maps.google.com/?cid=1692621507250340689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "credena-health-pharmacy-anchorage",
      "poi_latitude": "61.18832140000001",
      "poi_longitude": "-149.8177467",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-212-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e78-73a5-82e2-2538d198d68f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e78-73a5-82e2-2538d198d68f",
        "storage_key": "property/6767906449167166/019d021b-8e78-73a5-82e2-2538d198d68f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcgBSwCXyFYRUcPX_kpmfRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_7293b9fa-d9cc-4cb9-be00-aec812dedb85",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "725 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-ef9a-706a-a679-b9914590c50d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-ef9a-706a-a679-b9914590c50d",
        "storage_key": "property/6767906449167166/01a10de6-ef9a-706a-a679-b9914590c50d.webp",
        "width": 1213,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-725+e+northern+lights+blvd-anchorage-ak-99503/id=13656",
      "poi_directions_map_url": "https://maps.google.com/?cid=11830623915119265903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1959633",
      "poi_longitude": "-149.8686494",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-644-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmXnbSraXyFYRb8js-8TRLqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_f5d0275f-5206-410d-8113-beae74eba650",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "The Alaska Club Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "701 W 8th Ave Ste 100, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-6051-734e-898e-03f9729fd22a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-6051-734e-898e-03f9729fd22a",
        "storage_key": "property/6767906449167166/019d021b-6051-734e-898e-03f9729fd22a.webp",
        "width": 537,
        "height": 411
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacdt-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=9293149657447986627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-downtown",
      "poi_latitude": "61.21480699999999",
      "poi_longitude": "-149.8973812",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-274-4232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8916-7229-8bfa-7bf56568f51e",
        "storage_key": "property/6767906449167166/019d021b-8916-7229-8bfa-7bf56568f51e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxe52Ia9yFYRw_W6UGDm94A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c975c2c7-b141-4bc0-b824-4103fb8e194a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 A St, Anchorage, AK 99503, USA",
      "poi_short_description": "24/7 fitness center featuring diverse workout equipment and group training classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f2b1-7609-8032-0b2049f05068.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f2b1-7609-8032-0b2049f05068",
        "storage_key": "property/6767906449167166/01a10de6-f2b1-7609-8032-0b2049f05068.webp",
        "width": 540,
        "height": 405
      },
      "poi_business_url": "https://alaskafitness.net/?utm_source=omg-gbp&utm_medium=webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=9562682542507911640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-fitness",
      "poi_latitude": "61.19583309999999",
      "poi_longitude": "-149.8841078",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-646-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-117b-7227-9282-d8cde122fae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-117b-7227-9282-d8cde122fae4",
        "storage_key": "property/6767906449167166/01a10de7-117b-7227-9282-d8cde122fae4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxqTXM-XyFYR2GkDbht5tYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c7e28f91-5441-4d8a-9479-7c70d1269d72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Just Reign Cycle Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "2610 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Welcoming fitness center offering high-energy indoor cycling classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f303-772b-aa9f-043f638e1990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f303-772b-aa9f-043f638e1990",
        "storage_key": "property/6767906449167166/01a10de6-f303-772b-aa9f-043f638e1990.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.justreign.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12575621159470139560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "just-reign-cycle-studio",
      "poi_latitude": "61.197215",
      "poi_longitude": "-149.906851",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-562-7746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTzvf9mXyFYRqIga6NCUha4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5abea22e-8b8b-4bd9-b05f-932dd8a66ce0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Burn & Bloom",
      "poi_type": "Health and Wellness",
      "poi_address": "508 W 2nd Ave Ste 109, Anchorage, AK 99501, USA",
      "poi_short_description": "Welcoming, high-energy yoga studio offering challenging, movement-focused classes and red light therapy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f7de-727e-9b0e-eeda88e13928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f7de-727e-9b0e-eeda88e13928",
        "storage_key": "property/6767906449167166/01a10de6-f7de-727e-9b0e-eeda88e13928.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.burnbloom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3236109589624142074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burn--bloom",
      "poi_latitude": "61.2202141",
      "poi_longitude": "-149.8917751",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-720-8478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg9_ZliiWyFYR-jjIr4b46Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_be58d437-4568-421a-bb4f-bd1731a38f66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Delaney Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 9th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Big park with sports fields, tennis courts & horseshoe pits, plus an ice-hockey rink & skating area.",
      "poi_long_description": "Big park with sports fields, tennis courts & horseshoe pits, plus an ice-hockey rink & skating area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-35f9-760c-97a9-3d8ee72bd671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-35f9-760c-97a9-3d8ee72bd671",
        "storage_key": "property/6767906449167166/01a10de4-35f9-760c-97a9-3d8ee72bd671.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://muni.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1290405951593808698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaney-park",
      "poi_latitude": "61.213055",
      "poi_longitude": "-149.896227",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QWeniqWyFYROoPMSGBx6BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c13f8242-9201-4bbc-9fed-7f7e6091aaa1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Elderberry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1297 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Scenic city park offering coastal trail access and sunset views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f551-7448-88e3-d8d924c80d6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f551-7448-88e3-d8d924c80d6c",
        "storage_key": "property/6767906449167166/01a10de6-f551-7448-88e3-d8d924c80d6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16737905006090040660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elderberry-park",
      "poi_latitude": "61.21801979999999",
      "poi_longitude": "-149.9065414",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVccMwoO9yFYRVLU6_Ov7SOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d70f21ca-87da-4a9a-bef6-5c44b9ef5f1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Town Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "544 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Small park featuring flowers & concerts in the summer, plus ice sculptures & a rink in the winter.",
      "poi_long_description": "Small park featuring flowers & concerts in the summer, plus ice sculptures & a rink in the winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f51f-7379-8b6d-126a6d7c52e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f51f-7379-8b6d-126a6d7c52e7",
        "storage_key": "property/6767906449167166/01a10de6-f51f-7379-8b6d-126a6d7c52e7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12145788217067135527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-square-park",
      "poi_latitude": "61.217028",
      "poi_longitude": "-149.892606",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIytn_SmWyFYRJ2JpQwiCjqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_16ab5762-63dd-414d-8344-62e4dc9300d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Resolution Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "320 L St, Anchorage, AK 99501, USA",
      "poi_short_description": "Scenic city park featuring Captain Cook monument and expansive coastal views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f923-762c-a478-76a8d4f78f8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f923-762c-a478-76a8d4f78f8b",
        "storage_key": "property/6767906449167166/01a10de6-f923-762c-a478-76a8d4f78f8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15495371061981365711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "resolution-park",
      "poi_latitude": "61.21918559999999",
      "poi_longitude": "-149.9038468",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yqBH4S9yFYRz0VEBOKdCtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0253a26c-e4ef-45d0-8128-c56a98dce179",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Coastal Trail - 2nd and H St",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "H St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f61d-7585-8f8d-8794d20b039f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f61d-7585-8f8d-8794d20b039f",
        "storage_key": "property/6767906449167166/01a10de6-f61d-7585-8f8d-8794d20b039f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160247703349159867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coastal-trail---2nd-and-h-st",
      "poi_latitude": "61.22054069999999",
      "poi_longitude": "-149.8975039",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-117d-773c-a875-b6dfd0f439eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-117d-773c-a875-b6dfd0f439eb",
        "storage_key": "property/6767906449167166/01a10de7-117d-773c-a875-b6dfd0f439eb.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJhS349Ia9yFYRu-d-Gygq4Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_e682609f-bbb5-413e-90a0-5833306a948e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Margaret Eagan Sullivan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1824 W 15th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_long_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-f6b2-72ad-8dab-18a876678739.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-f6b2-72ad-8dab-18a876678739",
        "storage_key": "property/6767906449167166/01a10de6-f6b2-72ad-8dab-18a876678739.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10765612440412588611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "margaret-eagan-sullivan-park",
      "poi_latitude": "61.20760069999999",
      "poi_longitude": "-149.9170951",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwm4bXy9yFYRQ4pR1HkjZ5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_45fefcb6-d969-4024-983b-5025a758ed1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Valley of the Moon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "610 W 17th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Tree-lined green space with a large, modern playground, dog park, hiking trails & a creek.",
      "poi_long_description": "Tree-lined green space with a large, modern playground, dog park, hiking trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-33de-703f-923c-55f287b8d654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-33de-703f-923c-55f287b8d654",
        "storage_key": "property/6767906449167166/01a10de4-33de-703f-923c-55f287b8d654.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaska.org/detail/valley-of-the-moon-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13618989538806419726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-of-the-moon-park",
      "poi_latitude": "61.2049461",
      "poi_longitude": "-149.8945141",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0Huw9OXyFYRDlFRPNReAL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_de4d0641-ed04-4c98-9ff0-d584847d5c73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "William Jack Hernandez Sport Fish Hatchery",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "941 N Reeve Blvd, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-fa9e-70c9-aa82-84ac2eb61604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-fa9e-70c9-aa82-84ac2eb61604",
        "storage_key": "property/6767906449167166/01a10de6-fa9e-70c9-aa82-84ac2eb61604.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.adfg.alaska.gov/index.cfm%3Fadfg%3DfishingSportStockingHatcheryInfo.williamjackhernandez",
      "poi_directions_map_url": "https://maps.google.com/?cid=16014755792717838839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-jack-hernandez-sport-fish-hatchery",
      "poi_latitude": "61.2303681",
      "poi_longitude": "-149.8296703",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-444-6030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1ih-BKWyFYR93mTLYvXP94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ranch"
    },
    {
      "id": "custom_861ecb87-ea18-4d4f-b437-94406ccad67c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Earthquake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5101 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_long_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-38ba-74cf-8dd9-22168ed46087.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-38ba-74cf-8dd9-22168ed46087",
        "storage_key": "property/6767906449167166/01a10de4-38ba-74cf-8dd9-22168ed46087.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.anchorage.net/discover/trails-and-local-parks/earthquake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10919572690925706311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earthquake-park",
      "poi_latitude": "61.1984068",
      "poi_longitude": "-149.9802084",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2AwokC9yFYRR9yuDYIdipc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ce1b8c80-180f-449e-8722-7a6e7eb74833",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Point Woronzof Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9700 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_long_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-bc0f-7738-a2ba-2d60b6ff4526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-bc0f-7738-a2ba-2d60b6ff4526",
        "storage_key": "property/6767906449167166/019d021b-bc0f-7738-a2ba-2d60b6ff4526.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3646899879165127207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-woronzof-park",
      "poi_latitude": "61.2011236",
      "poi_longitude": "-150.0203185",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-89e4-75e8-9b74-0cb78ce65409",
        "storage_key": "property/6767906449167166/019d021b-89e4-75e8-9b74-0cb78ce65409.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7F3TS29yFYRJ2oNNR5knDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9c771f6a-10a9-41a5-92c7-a6dde7039cdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-fd3d-779c-973c-87fb712872c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-fd3d-779c-973c-87fb712872c0",
        "storage_key": "property/6767906449167166/01a10de6-fd3d-779c-973c-87fb712872c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ce1fd2a9-a0cd-46e0-923a-51fe4e949499",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-37f0-7474-8d6c-efbfb7e56a22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-37f0-7474-8d6c-efbfb7e56a22",
        "storage_key": "property/6767906449167166/01a10de4-37f0-7474-8d6c-efbfb7e56a22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.2216964",
      "poi_longitude": "-149.8901898",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e80-7228-bb8c-71d466d4f0fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e80-7228-bb8c-71d466d4f0fc",
        "storage_key": "property/6767906449167166/019d021b-8e80-7228-bb8c-71d466d4f0fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e7f241e8-1c7a-4188-8322-ddba1e69c0db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-3447-72ce-a0c1-8a14011992b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-3447-72ce-a0c1-8a14011992b5",
        "storage_key": "property/6767906449167166/01a10de4-3447-72ce-a0c1-8a14011992b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8ec7-7706-85a0-0d867263aa9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8ec7-7706-85a0-0d867263aa9f",
        "storage_key": "property/6767906449167166/019d021b-8ec7-7706-85a0-0d867263aa9f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_54e98cad-2cf0-4721-aea3-703798b71ac1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-fe05-759b-8485-36f250b8cd39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-fe05-759b-8485-36f250b8cd39",
        "storage_key": "property/6767906449167166/01a10de6-fe05-759b-8485-36f250b8cd39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-1186-706e-80ff-fac550fc2920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-1186-706e-80ff-fac550fc2920",
        "storage_key": "property/6767906449167166/01a10de7-1186-706e-80ff-fac550fc2920.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c61bff2c-68f7-41be-b67a-840f0b6a889f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Central Transfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1208 E 56th Ave, Anchorage, AK 99518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-ffb4-7578-bb04-4eaf5fbd674b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-ffb4-7578-bb04-4eaf5fbd674b",
        "storage_key": "property/6767906449167166/01a10de6-ffb4-7578-bb04-4eaf5fbd674b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/SWS/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11377918452066376081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-transfer-station",
      "poi_latitude": "61.16845619999999",
      "poi_longitude": "-149.8603621",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-343-6250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36RUMnqXyFYRkVnHoox85p0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_868da63f-5503-463a-b505-b37f63fa52f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Eagle River Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99577, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de6-ffef-765d-a50b-d9a961dc460e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de6-ffef-765d-a50b-d9a961dc460e",
        "storage_key": "property/6767906449167166/01a10de6-ffef-765d-a50b-d9a961dc460e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5293723384036886587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagle-river-transit-center",
      "poi_latitude": "61.32776500000001",
      "poi_longitude": "-149.573677",
      "poi_miles_from_property": "15.6",
      "poi_walking_minutes": "5 hours 44 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-1186-706e-80ff-fac550fc2920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10de7-1186-706e-80ff-fac550fc2920",
        "storage_key": "property/6767906449167166/01a10de7-1186-706e-80ff-fac550fc2920.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJb--R-XLryFYRO4iy1F4Vd0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_42d6078a-f54d-42e6-a703-26ef6a0fb9c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de4-3aa2-767d-8835-59130a094a8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de4-3aa2-767d-8835-59130a094a8d",
        "storage_key": "property/6767906449167166/01a10de4-3aa2-767d-8835-59130a094a8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.21632990000001",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8a22-74e6-87c3-cb279da45833.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8a22-74e6-87c3-cb279da45833",
        "storage_key": "property/6767906449167166/019d021b-8a22-74e6-87c3-cb279da45833.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_25eb76f4-82c1-4eae-b679-84349ec01609",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Robert B. Atwood Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "550 W 7th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-0183-7363-a9c4-c525e07c07c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de7-0183-7363-a9c4-c525e07c07c0",
        "storage_key": "property/6767906449167166/01a10de7-0183-7363-a9c4-c525e07c07c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7609883085298722019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-b-atwood-building",
      "poi_latitude": "61.2154191",
      "poi_longitude": "-149.893055",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-269-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8a22-74e6-87c3-cb279da45833.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8a22-74e6-87c3-cb279da45833",
        "storage_key": "property/6767906449167166/019d021b-8a22-74e6-87c3-cb279da45833.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm9prESqWyFYR4-R74Vi8m2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_c780f71a-447e-4787-a330-b8a7e67a6804",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-7879-7118-ac9d-11ffbf45928c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-7879-7118-ac9d-11ffbf45928c",
        "storage_key": "property/6767906449167166/019d021b-7879-7118-ac9d-11ffbf45928c.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e0f-72e7-9aa4-1dfcc998bdfa",
        "storage_key": "property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_40e5d71c-45db-4017-ba51-4fa5202cc78b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Southcentral Foundation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4320 Diplomacy Dr #2300, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3019730341503088136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation",
      "poi_latitude": "61.1816621",
      "poi_longitude": "-149.7999688",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-729-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTcpchyXyFYRCLbCEr886Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_b43f1e8a-be5a-4f68-988b-e436defc41c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-52c9-750f-960a-90f0438b532f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-52c9-750f-960a-90f0438b532f",
        "storage_key": "property/6767906449167166/019d021b-52c9-750f-960a-90f0438b532f.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2107038",
      "poi_longitude": "-149.8288584",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-8e0f-72e7-9aa4-1dfcc998bdfa",
        "storage_key": "property/6767906449167166/019d021b-8e0f-72e7-9aa4-1dfcc998bdfa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f70272fd-b0ed-4640-b5b2-202cb032431d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "custom",
      "poi_name": "Alaska Railroad Corporation",
      "poi_type": "Transportation & Transit",
      "poi_address": "327 W Ship Creek Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/01a10de7-02f7-76be-8e98-ec99ebbf87f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10de7-02f7-76be-8e98-ec99ebbf87f5",
        "storage_key": "property/6767906449167166/01a10de7-02f7-76be-8e98-ec99ebbf87f5.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "https://www.alaskarailroad.com/corporate",
      "poi_directions_map_url": "https://maps.google.com/?cid=13146147969309211409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-railroad-corporation",
      "poi_latitude": "61.22278739999999",
      "poi_longitude": "-149.8881884",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-265-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-85c4-701e-8864-dfb675f8754b",
        "storage_key": "property/6767906449167166/019d021b-85c4-701e-8864-dfb675f8754b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbzebYi9yFYREftlQ-1_cLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2e744448758638295ac89240",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6bb54e5dbd599b1a5217bff6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_75df035a3c75e47302076b04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9a6dd51f3230acb45dce4a8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4e915ae350a86e87f9abce30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_d83b8bd819f9cb49a61ea2ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "2472481",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_315207b506844d738b106911",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "yardi",
      "external_id": "2472480",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-e5d8-708f-a54f-d74526d07954",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Alaskan Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartments-dishwashers-anchorage-ak",
      "search_query": "apartments with dishwashers Anchorage AK",
      "category": "Amenity",
      "h1_title": "Find Apartments with Dishwashers in Anchorage",
      "h2_subtitle": "Discover the convenience of living in Anchorage AK apartments with dishwashers. Simplify your lifestyle with our top-notch amenities today.",
      "page_copy": "Experience a blend of modernity and convenience at the Alaskan, located in the heart of Anchorage, AK. Our apartments come equipped with dishwashers, ensuring your chores are hassle-free. Situated in the South Addition neighborhood, this home combines comfort with practicality. \n\nAlaskan offers more than just apartments with dishwashers. It's a community that values your lifestyle. Enjoy 24-hour access to essential amenities, a dedicated office space, and reside in a pet-friendly environment. Come and see how living in Anchorage can be an exceptional experience when you choose the Alaskan.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers - Anchorage AK",
      "seo_description": "Explore Anchorage AK apartments with dishwashers at the Alaskan. Enjoy modern amenities and a convenient lifestyle in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-south-addition",
      "search_query": "smoke free apartments South Addition",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments in South Addition",
      "h2_subtitle": "Discover smoke-free apartments in South Addition, offering a clean and healthy living environment. Enjoy modern amenities in a prime location.",
      "page_copy": "Discover your next home at the Alaskan, where comfort meets a healthy living environment in South Addition. Our smoke-free apartments provide a breath of fresh air, ensuring a clean and serene home for all residents.\n\nLocated in Anchorage, these apartments offer more than just a smoke-free policy. Benefit from a built-in office/desk, ceiling fans, and a convenient in-unit dishwasher. With 24-hour access and a host of amenities, the Alaskan meets all your lifestyle needs without compromising on comfort or location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments - South Addition",
      "seo_description": "Find your smoke-free apartment in South Addition at the Alaskan. Enjoy a clean living space with modern amenities in a prime Anchorage location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "balcony-apartments-anchorage-municipality",
      "search_query": "balcony apartments Anchorage Municipality",
      "category": "Amenity",
      "h1_title": "Balcony Apartments in Anchorage Municipality",
      "h2_subtitle": "Embrace the outdoors in Anchorage Municipality with our balcony apartments. Enjoy modern amenities in a welcoming community.",
      "page_copy": "Welcome to Alaskan, where comfort and scenic views come together in Anchorage Municipality. Although our units currently feature other desirable amenities, such as built-in offices/desks and dishwashers, the community spirit makes each home feel complete. Should a balcony be your preference, we encourage you to explore the full benefits our community offers, including 24-hour access and spacious layouts.\n\nNestled in the vibrant South Addition neighborhood, Alaskan offers a perfect blend of tranquility and convenience. While our units do not have balconies, our community atmosphere allows residents to enjoy outdoor experiences in a delightful Anchorage setting. Choose Alaskan for a unique living experience, where every day is made exceptional with tailored amenities and a smoke-free environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Balcony Apartments - Anchorage Municipality",
      "seo_description": "Explore balcony apartments in Anchorage Municipality. Experience the Alaskan lifestyle with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "online-payment-apartments-99501",
      "search_query": "online payment apartments in 99501",
      "category": "Amenity",
      "h1_title": "Online Payment Apartments in 99501",
      "h2_subtitle": "Convenience at your fingertips with online payment options in 99501. Experience modern living at the Alaskan.",
      "page_copy": "Discover the ease and convenience of modern living at Alaskan, located in the vibrant area of Anchorage with the 99501 zip code. Our community prioritizes your convenience by offering online payment options, making the rent process seamless and hassle-free. With this added benefit, managing your monthly rent has never been easier.\n\nSet in the charming South Addition neighborhood, the Alaskan also boasts a range of amenities such as built-in offices, dishwashers, and ceiling fans, ensuring comfort in a smoke-free environment. Experience the best of Anchorage with us, where advanced technology meets exceptional service, all designed to improve your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Online Payment Apartments - 99501",
      "seo_description": "Find online payment apartments in 99501 at the Alaskan. Enjoy easy living with modern amenities in Anchorage's South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartment-resident-events-south-addition",
      "search_query": "apartment resident events South Addition Anchorage",
      "category": "Amenity",
      "h1_title": "Apartment Resident Events in South Addition",
      "h2_subtitle": "Join vibrant apartment resident events in South Addition, Anchorage. Connect with community at the Alaskan.",
      "page_copy": "At the Alaskan, we believe community is key. That's why our apartment resident events in South Addition, Anchorage, are designed to foster a sense of belonging among neighbors. These gatherings provide the perfect opportunity to make new friends, connect with fellow residents, and build cherished memories, right here in the heart of Anchorage.\n\nWhile enjoying community events, residents also benefit from the array of amenities available at the Alaskan, including a built-in office/desk, in-unit dishwasher, and ceiling fans. Set in a smoke-free environment, our community encourages not only social interaction but also comfortable living in a prime location. Join us at the Alaskan, where events and modern conveniences enhance the quality of life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Resident Events - South Addition",
      "seo_description": "Discover apartment resident events in South Addition, Anchorage. Enjoy community living and vibrant events at the Alaskan.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "studio-apartments-south-addition-anchorage",
      "search_query": "studio apartments south addition anchorage",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in South Addition Anchorage",
      "h2_subtitle": "Discover cozy studio apartments in South Addition, Anchorage, designed for modern living at the Alaskan.",
      "page_copy": "Experience the charm and convenience of studio apartments in South Addition, Anchorage, at the Alaskan. These compact yet efficient living spaces are perfect for individuals seeking comfort combined with accessibility. Nestled in one of Anchorage’s most desirable neighborhoods, our studio apartments provide a cozy retreat while placing you within reach of all the local attractions.\n\nEach unit at the Alaskan features modern amenities such as built-in desks, dishwashers, and ceiling fans, ensuring a comfortable living environment. The South Addition offers a unique blend of serenity and urban convenience, making it the ideal place for those who value both peace and proximity to city life. Join our community and enjoy the benefits of stylish living in a community-focused environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments - South Addition Anchorage",
      "seo_description": "Explore studio apartments in South Addition, Anchorage at the Alaskan. Enjoy modern amenities in a vibrant yet cozy setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "1-bedroom-floorplans-anchorage-ak",
      "search_query": "1 bedroom floorplans anchorage ak",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Floorplans in Anchorage, AK",
      "h2_subtitle": "Explore versatile 1 bedroom floorplans in Anchorage, AK. Discover your ideal home at the Alaskan.",
      "page_copy": "Step into comfortable living with our carefully designed 1 bedroom floorplans in Anchorage, AK, at the Alaskan. Each unit is thoughtfully laid out to maximize space and functionality, offering the perfect blend of comfort and style. Whether you're down-sizing or starting fresh, our floorplans are tailored to meet diverse lifestyle needs.\n\nLocated in the heart of Anchorage’s vibrant community, the Alaskan offers more than just a place to live. Enjoy amenities like a built-in desk, dishwashers, and ceiling fans in every unit, enhancing your everyday living experience. Conveniently situated in the scenic South Addition neighborhood, our community provides easy access to local entertainment, shopping, and dining. Make the Alaskan your new home and experience the best Anchorage has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Floorplans - Anchorage, AK",
      "seo_description": "Find 1 bedroom floorplans in Anchorage, AK at the Alaskan. Enjoy modern amenities and a vibrant lifestyle in South Addition.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-99501",
      "search_query": "2 bedroom apartments near 99501",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 99501",
      "h2_subtitle": "Discover spacious 2 bedroom apartments near 99501. Enjoy comfort and modern amenities at the Alaskan.",
      "page_copy": "Searching for the perfect home? Explore our spacious 2 bedroom apartments near the 99501 area at the Alaskan. These units are ideal for families, roommates, or individuals who desire extra space. With spacious layouts, each apartment offers the flexibility and room you need to live comfortably and entertain guests easily.\n\nSituated in the heart of Anchorage, just steps from the vibrant South Addition neighborhood, the Alaskan provides a community environment intertwined with urban convenience. Our apartments come equipped with modern amenities like built-in desks, dishwashers, and ceiling fans. Join the Alaskan community and enjoy easy access to local shopping, dining, and entertainment, making it easier than ever to enjoy life in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 99501",
      "seo_description": "Explore 2 bedroom apartments near 99501 at the Alaskan. Enjoy comfort, modern amenities, and a vibrant location in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-alaska-anchorage",
      "search_query": "apartments near university of alaska anchorage",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Discover convenient apartments near the University of Alaska Anchorage. Perfect for students and professionals at the Alaskan.",
      "page_copy": "Find the perfect home at the Alaskan with our apartments near the University of Alaska Anchorage. These residences provide an ideal base for students and professionals seeking proximity to campus while enjoying all the comfort of a modern apartment. Our community offers an unbeatable location, just a short commute away from the university, allowing you more time to focus on studies and activities.\n\nThe Alaskan's amenities, including built-in desks, dishwashers, and ceiling fans, are designed to support a productive and enjoyable lifestyle. Located in the vibrant South Addition neighborhood, you’ll have easy access to a variety of local shops, restaurants, and cafes, creating a balanced lifestyle between work and play. Experience the best of Anchorage living with convenience and style at the Alaskan.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Find convenient apartments near the University of Alaska Anchorage at the Alaskan. Ideal for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center",
      "search_query": "apartments near Alaska Native Medical Center Anchorage Municipality",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Explore the perfect apartments near Alaska Native Medical Center in Anchorage Municipality. Enjoy comfort at the Alaskan.",
      "page_copy": "If you're looking for a home near Alaska Native Medical Center in Anchorage Municipality, the Alaskan offers the perfect setting. Our apartments are ideal for healthcare professionals seeking proximity to their workplace or patients' families wanting convenient accommodation. Each unit is designed to foster a comfortable living experience with modern amenities such as built-in office desks, dishwashers, and ceiling fans.\n\nLocated in the serene South Addition neighborhood, the Alaskan provides a peaceful retreat near the bustle of the medical center. Enjoy easy access to local amenities, dining, and entertainment, all while staying close to the medical hub. Experience the ease of a short commute and the relaxation of a welcoming community at the Alaskan.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Discover apartments near Alaska Native Medical Center in Anchorage Municipality. Enjoy modern living at the Alaskan.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-alaska-medical-center",
      "search_query": "apartments close to Providence Alaska Medical Center 99501",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence Alaska Medical Center",
      "h2_subtitle": "Find your ideal apartment close to Providence Alaska Medical Center in the heart of Anchorage. The Alaskan offers modern living.",
      "page_copy": "For those seeking a convenient location near Providence Alaska Medical Center, the Alaskan provides perfectly situated apartments just a short drive away from the 99501 area. Ideal for medical professionals, patients, or visitors, our community offers the necessary amenities and comfort that align with busy schedules and demanding lifestyles.\n\nNestled in Anchorage’s charming South Addition, the Alaskan combines convenience with a supportive environment perfect for unwinding after a long day. Our apartments feature built-in desks, dishwashers, and ceiling fans, blending functionality with comfort. Experience the balance of easy access to healthcare facilities and the welcoming community atmosphere that defines life at the Alaskan.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Providence Alaska Medical Center",
      "seo_description": "Discover modern apartments close to Providence Alaska Medical Center in Anchorage at the Alaskan. Perfect for professionals and patients alike.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartments-near-earthquake-park-anchorage",
      "search_query": "apartments near Earthquake Park Anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Earthquake Park Anchorage",
      "h2_subtitle": "Explore convenient apartments near Earthquake Park in Anchorage. Enjoy nature and comfort at the Alaskan.",
      "page_copy": "Live near one of Anchorage's stunning natural attractions at the Alaskan, where you can find apartments near Earthquake Park. This location is perfect for nature lovers and outdoor enthusiasts, offering easy access to picturesque trails and recreational activities. Reside in the South Addition neighborhood, where the hustle of city life meets serene park landscapes.\n\nThe Alaskan welcomes you with amenities designed to enhance your living experience, including built-in desks for home projects, dishwashers for daily convenience, and ceiling fans for comfort. Embrace a lifestyle that balances city amenities with nature's tranquility, providing the perfect backdrop for relaxation and exploration. Proximity to Earthquake Park ensures that stunning views and outdoor pursuits are always within reach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Earthquake Park Anchorage",
      "seo_description": "Discover the Alaskan's apartments near Earthquake Park in Anchorage. Perfect for nature enthusiasts seeking comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "south-addition-apartments-near-alaska-botanical-garden",
      "search_query": "South Addition apartments close to Alaska Botanical Garden",
      "category": "Park",
      "h1_title": "South Addition Apartments Near Alaska Botanical Garden",
      "h2_subtitle": "Find charming South Addition apartments close to the Alaska Botanical Garden. Experience nature at the Alaskan.",
      "page_copy": "Enjoy the best of Anchorage living at the Alaskan, offering South Addition apartments close to the Alaska Botanical Garden. With lush landscapes and serene paths, the garden provides an exceptional natural escape just minutes from your doorstep. Perfectly situated in the South Addition neighborhood, the Alaskan combines suburban tranquility with city convenience.\n\nOur thoughtfully designed apartments feature amenities like built-in desks, dishwashers, and ceiling fans to suit your lifestyle needs. Whether you're seeking a peaceful retreat or a place to explore the natural wonders of Anchorage, the Alaskan offers an ideal location. Enjoy easy access to both the beauty of the Alaska Botanical Garden and the vibrant life of South Addition, making it an unbeatable place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Addition Apartments Near Alaska Botanic Garden",
      "seo_description": "Explore South Addition apartments near the Alaska Botanical Garden at the Alaskan. Perfect blend of nature and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "delaney-park-nearby-apartment-rentals-anchorage-ak",
      "search_query": "Delaney Park nearby apartment rentals Anchorage AK",
      "category": "Park",
      "h1_title": "Delaney Park Nearby Apartment Rentals Anchorage",
      "h2_subtitle": "Discover apartment rentals near Delaney Park in Anchorage, AK. Enjoy vibrant city life at the Alaskan.",
      "page_copy": "Experience the delightful combination of urban living and park access with apartment rentals near Delaney Park in Anchorage, AK. At the Alaskan, you'll find the perfect haven nestled in the South Addition neighborhood, providing you with beautiful park views and convenient city amenities. Delaney Park offers ample green space and recreational activities, making it a cherished spot for residents.\n\nThe Alaskan delivers a modern living experience with essential comforts, including built-in desks for work or study, dishwashers for added ease, and ceiling fans for those warmer days. Our apartments are ideally located, offering quick access to Delaney Park, where you can enjoy a leisurely walk, exercise, or simply unwind in nature. Discover the ideal blend of vibrant city life and serene park setting at the Alaskan.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Delaney Park Nearby Apartment Rentals Anchorage",
      "seo_description": "Find apartment rentals near Delaney Park in Anchorage at the Alaskan. Enjoy city living with park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167166",
      "source": "generator",
      "page_item_url": "apartments-near-anchorage-international-airport",
      "search_query": "apartments near Anchorage International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Anchorage International Airport",
      "h2_subtitle": "Explore convenient apartments near Anchorage International Airport. Enjoy quick access at the Alaskan.",
      "page_copy": "For those seeking convenience and accessibility, consider apartments near Anchorage International Airport at the Alaskan. Located in the vibrant South Addition neighborhood, these apartments offer easy access to one of Alaska's major travel hubs. Whether you're a frequent flyer or simply value proximity to the airport, the Alaskan provides an ideal living situation.\n\nOur apartments are outfitted with modern amenities such as built-in desks, efficient dishwashers, and ceiling fans, catering to both comfort and functionality. Living near the airport allows for easy travel without the hassle, all while enjoying the lifestyle and cultural experiences that Anchorage offers. Choose the Alaskan for a perfect combination of location, convenience, and modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Anchorage International Airport",
      "seo_description": "Discover Alaskan apartments near Anchorage International Airport. Ideal for easy travel and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309335721"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085595"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/18874b4e-736e-4a09-ace3-1c552a358e03/app.js?property=18874b4e-736e-4a09-ace3-1c552a358e03&propertyName=The+Alaskan&channelUuid=c249006a-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkZuU0RJUEtBLzB3azI1YnlmNkN1REE9PSIsInZhbHVlIjoic24vdVQxbzBoRSt2UGNwNDZHSVF5Zz09IiwibWFjIjoiYzIzNTU5ZTM2ZjFiOWNiMjg1YWJjNDg0MjNjZGQyYjcyZTk5NGFmY2ZlMGI2MTY1ZTM4MjFhOTU5ODExNWZlNiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309335721",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085595",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/18874b4e-736e-4a09-ace3-1c552a358e03/app.js?property=18874b4e-736e-4a09-ace3-1c552a358e03&propertyName=The+Alaskan&channelUuid=c249006a-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkZuU0RJUEtBLzB3azI1YnlmNkN1REE9PSIsInZhbHVlIjoic24vdVQxbzBoRSt2UGNwNDZHSVF5Zz09IiwibWFjIjoiYzIzNTU5ZTM2ZjFiOWNiMjg1YWJjNDg0MjNjZGQyYjcyZTk5NGFmY2ZlMGI2MTY1ZTM4MjFhOTU5ODExNWZlNiJ9",
  "custom_audioeye_site_id": "de1e960f-4fe3-4883-8d6a-32d62041a100",
  "custom_audioeye_site_hash": "d7d11e76c64bc2c3bd00bb277aa94bfe"
};

export const generatedAt = '2026-11-04T23:36:12.424Z';
